import {NgModule} from '@angular/core';
import {AddPatternShiftDialogComponent} from '@presentation/components/calendar/add-pattern-shift-dialog/add-pattern-shift-dialog.component';
import {SharedModule} from '@shared/shared.module';
import {TimePickerFormInputModule} from '@vdw/angular-component-library';
import {calendarRouting} from './calendar.routing';

@NgModule({
  imports: [calendarRouting, SharedModule, TimePickerFormInputModule],
  declarations: [AddPatternShiftDialogComponent]
})
export class CalendarModule {}
